import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useUserRoleMatchCategory } from 'utils/hooks';
import { roleCategories } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import DistributorUsersTable from './DistributorUsersTable';
import InviteUser from '../components/InviteUser';
import { ListContainer } from 'components';

const DistributorUsers = () => {
    const userIsSerevicer = useUserRoleMatchCategory(roleCategories.SERVICERS);
    return (
        <ListContainer>
            <Routes>
                {!userIsSerevicer && (
                    <Route
                        path="invite"
                        element={<InviteUser title={texts.CREATE_USER} type="cif" />}
                    />
                )}
                <Route index element={<DistributorUsersTable />} />
                <Route path="*" element={<Navigate to="/distributor-users" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default DistributorUsers;
